import styled from "styled-components";
import { theme } from "../../../../../theme";

export const AvatarWrapper = styled('div')`
  margin-bottom: ${theme.offsets.extraMajor};
  @media(max-width: ${theme.screens.tablet}) {
    margin-bottom: ${theme.offsets.extraBig};
  }
  @media(max-width: ${theme.screens.mobile}) {
    margin-bottom: ${theme.offsets.xxl};
  }
  @media(max-width: ${theme.screens.mobileSmall}) {
    button{
      height: auto;
    }
  }
`

export const ButtonWrap = styled('div')`
& button{
  margin-right: ${theme.offsets.lg};
  margin-top: ${theme.offsets.lg};
  width: auto;
  padding-left: ${theme.offsets.lg};
  padding-right: ${theme.offsets.lg};
  font-size: 14px;
  @media(max-width: ${theme.screens.tablet}) {
    padding-left: ${theme.offsets.lg};
    padding-right: ${theme.offsets.lg};
    font-size: 12px;
  }
  svg{
    margin-left: ${theme.offsets.sm};
    @media(max-width: ${theme.screens.tablet}) {
      width: 16px;
      height: 16px;
    }
  }
}
`

export const FieldHeader = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: center;
  padding: ${theme.offsets.xxl} 0;
  border-top: 1px solid ${theme.colors.lightGray};
  margin-top: ${theme.offsets.extraBig};
  @media(max-width: ${theme.screens.tablet}) {
    margin-top: ${theme.offsets.xxl};
    padding: ${theme.offsets.lg} 0;
  }
`

export const ArrayItemTitle = styled('div')`
  font-size: ${theme.fontSizes.xxl};
  color: ${theme.colors.black};
  display: flex;
  align-items: flex-start;
  @media(max-width: ${theme.screens.tablet}) {
    font-size: ${theme.fontSizes.xl};
    margin: ${theme.offsets.md} 0;
  }
`

export const RemoveBtn = styled('span')`
  font-weight: 500;
  font-size: ${theme.offsets.lg};
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.lightOrange};
`